export const getMainRedirectPath = ({
  isHasAccessOrganization,
  isHasAccessIndividual,
  isHasAccessOffering,
}: {
  isHasAccessOrganization: boolean;
  isHasAccessIndividual: boolean;
  isHasAccessOffering: boolean;
}): string => {
  if (isHasAccessOrganization) {
    return "accounts/list";
  }
  if (isHasAccessIndividual) {
    return "accounts/individual";
  }
  if (isHasAccessOffering) {
    return "offer/list";
  }

  return "welcome";
};
